export default __webpack_public_path__ + "static/media/blog-3.b5246244.jpg";